module.exports = __webpack_public_path__ + "static/businness-card-3-15f9d486139c80ca830032ae313e62c9.jpg";